import Colors, { mediumColors } from "shared/helpers/colors";
import { MentionType, SocialMentionType } from "shared/types/mentions";

import { MediumField, type SocialMedium, SocialPlatform } from "./types";

export const socialMedia: SocialMedium = {
  categoryLocationFiltersEnabled: true,
  color: mediumColors.social,
  displayExcerptsFeature: "has_social_platform",
  featureFlag: "has_social_platform",
  field: MediumField.SOCIAL,
  filterEnabled: true,
  hasNotification: true,
  icon: `${import.meta.env.VITE_ASSETS_URL}/icons/social.svg`,
  label: "Social",
  medium: "Social",
  platforms: [
    {
      checked: true,
      color: "#77BDF1",
      featureFlag: "view_tweet",
      fields: [SocialMentionType.tweet],
      icon: `${import.meta.env.VITE_ASSETS_URL}/icons/twitter.svg`,
      label: "X | Twitter",
      platform: SocialPlatform.TWITTER,
      widgets: ["key_twitter_influencers", "top_tweets"],
    },
    {
      checked: true,
      color: "#61749D",
      featureFlag: "view_facebook_post",
      fields: [SocialMentionType.facebook_post],
      icon: `${import.meta.env.VITE_ASSETS_URL}/icons/facebook.svg`,
      label: "Facebook",
      platform: SocialPlatform.FACEBOOK,
      widgets: ["top_facebook_pages", "top_facebook_posts"],
    },
    {
      checked: true,
      color: "#E3787C",
      featureFlag: "view_instagram_post",
      fields: [
        SocialMentionType.instagram_post,
        SocialMentionType.instagram_comment,
      ],
      icon: `${import.meta.env.VITE_ASSETS_URL}/icons/instagram.svg`,
      label: "Instagram",
      platform: SocialPlatform.INSTAGRAM,
      widgets: ["top_instagram_posts", "key_instagram_influencers"],
    },
    {
      checked: true,
      color: "#D54B3F",
      featureFlag: "view_youtube_video",
      fields: [SocialMentionType.youtube_video],
      icon: `${import.meta.env.VITE_ASSETS_URL}/icons/youtube.svg`,
      label: "YouTube",
      platform: SocialPlatform.YOUTUBE,
      widgets: ["top_youtube_videos", "key_youtube_influencers"],
    },
    {
      checked: true,
      color: Colors.reddit,
      featureFlag: "view_reddit_post",
      fields: [
        SocialMentionType.reddit_post,
        SocialMentionType.reddit_post_comment,
        SocialMentionType.exorde_reddit_post,
        SocialMentionType.exorde_reddit_post_comment,
      ],
      icon: `${import.meta.env.VITE_ASSETS_URL}/icons/exorde-reddit.svg`,
      label: "Reddit",
      platform: SocialPlatform.REDDIT,
    },
    {
      checked: true,
      color: "#F06A35",
      featureFlag: "view_blog_post",
      fields: [SocialMentionType.blog_post],
      icon: `${import.meta.env.VITE_ASSETS_URL}/icons/blog.svg`,
      label: "Blogs",
      platform: SocialPlatform.BLOG,
    },
    {
      checked: true,
      color: "#FFB649",
      featureFlag: "view_forum_post",
      fields: [SocialMentionType.forum_post],
      icon: `${import.meta.env.VITE_ASSETS_URL}/icons/forum.svg`,
      label: "Forums",
      platform: SocialPlatform.FORUM,
    },
    {
      checked: true,
      color: "#1285FE",
      featureFlag: "view_bluesky_post",
      fields: [SocialMentionType.bluesky_post],
      icon: `${import.meta.env.VITE_ASSETS_URL}/icons/bluesky.svg`,
      label: "Bluesky",
      platform: SocialPlatform.BLUESKY,
      widgets: ["top_bluesky_posts", "key_bluesky_influencers"],
    },
    {
      checked: true,
      color: "#0274B3",
      featureFlag: "view_linkedin_post",
      fields: [
        SocialMentionType.linkedin_post,
        SocialMentionType.linkedin_comment,
      ],
      icon: `${import.meta.env.VITE_ASSETS_URL}/icons/linkedin.svg`,
      label: "LinkedIn",
      platform: SocialPlatform.LINKEDIN,
      widgets: ["top_linkedin_posts"],
    },
    {
      checked: true,
      color: "#FE2C55",
      featureFlag: "view_tiktok_video",
      fields: [
        SocialMentionType.tiktok_comment,
        SocialMentionType.tiktok_video,
      ],
      icon: `${import.meta.env.VITE_ASSETS_URL}/icons/tiktok.svg`,
      label: "TikTok",
      platform: SocialPlatform.TIKTOK,
      widgets: ["top_tiktok_videos"],
    },
  ],
  relatedCamelCaseFields: [
    "Tweet",
    "FacebookPost",
    "YoutubeVideo",
    "InstagramPost",
    "InstagramComment",
    "RedditPost",
    "RedditPostComment",
    "ExordeRedditPost",
    "ExordeRedditPostComment",
    "BlogPost",
    "ForumPost",
    "BlueskyPost",
    "LinkedinPost",
    "LinkedinComment",
    "TiktokComment",
    "TiktokVideo",
  ],
  relatedFields: [
    MentionType.tweet,
    MentionType.facebook_post,
    MentionType.youtube_video,
    MentionType.instagram_post,
    MentionType.instagram_comment,
    MentionType.reddit_post,
    MentionType.reddit_post_comment,
    MentionType.exorde_reddit_post,
    MentionType.exorde_reddit_post_comment,
    MentionType.blog_post,
    MentionType.forum_post,
    MentionType.bluesky_post,
    MentionType.linkedin_post,
    MentionType.linkedin_comment,
    MentionType.tiktok_comment,
    MentionType.tiktok_video,
  ],
  relatedLabels: [
    "Tweet",
    "FacebookPost",
    "YoutubeVideo",
    "InstagramPost",
    "InstagramComment",
    "RedditPost",
    "RedditPostComment",
    "ExordeRedditPost",
    "ExordeRedditPostComment",
    "BlogPost",
    "ForumPost",
    "BlueskyPost",
    "LinkedinPost",
    "LinkedinComment",
    "TiktokComment",
    "TiktokVideo",
  ],
  relatedTypes: [
    {
      appLabel: "Twitter",
      checked: true,
      color: "#77BDF1",
      featureFlag: "view_tweet",
      field: MentionType.tweet,
      icon: `${import.meta.env.VITE_ASSETS_URL}/icons/twitter.svg`,
      label: "Tweet",
    },
    {
      appLabel: "Facebook",
      checked: true,
      color: "#61749D",
      featureFlag: "view_facebook_post",
      field: MentionType.facebook_post,
      icon: `${import.meta.env.VITE_ASSETS_URL}/icons/facebook.svg`,
      label: "Facebook Post",
    },
    {
      appLabel: "Instagram",
      checked: true,
      color: "#E3787C",
      featureFlag: "view_instagram_post",
      field: MentionType.instagram_post,
      icon: `${import.meta.env.VITE_ASSETS_URL}/icons/instagram.svg`,
      label: "Instagram Post",
    },
    {
      appLabel: "Instagram Comments",
      checked: true,
      color: "#E3787C",
      featureFlag: "view_instagram_post",
      field: MentionType.instagram_comment,
      hidden: true,
      icon: `${import.meta.env.VITE_ASSETS_URL}/icons/instagram.svg`,
      label: "Instagram Comment",
    },
    {
      appLabel: "Youtube",
      checked: true,
      color: "#D54B3F",
      featureFlag: "view_youtube_video",
      field: MentionType.youtube_video,
      icon: `${import.meta.env.VITE_ASSETS_URL}/icons/youtube.svg`,
      label: "YouTube Video",
    },
    {
      appLabel: "Reddit Posts",
      checked: true,
      color: Colors.reddit,
      featureFlag: "view_reddit_post",
      field: MentionType.reddit_post,
      hidden: true,
      icon: `${import.meta.env.VITE_ASSETS_URL}/icons/exorde-reddit.svg`,
      label: "Reddit Post",
    },
    {
      appLabel: "Reddit Comments",
      checked: true,
      color: Colors.reddit,
      featureFlag: "view_reddit_post",
      field: MentionType.reddit_post_comment,
      hidden: true,
      icon: `${import.meta.env.VITE_ASSETS_URL}/icons/exorde-reddit.svg`,
      label: "Reddit Post Comment",
    },
    {
      appLabel: "Reddit Posts",
      checked: true,
      color: Colors.reddit,
      featureFlag: "view_reddit_post",
      field: MentionType.exorde_reddit_post,
      hidden: true,
      icon: `${import.meta.env.VITE_ASSETS_URL}/icons/exorde-reddit.svg`,
      label: "Reddit Post",
    },
    {
      appLabel: "Reddit Comments",
      checked: true,
      color: Colors.reddit,
      featureFlag: "view_reddit_post",
      field: MentionType.exorde_reddit_post_comment,
      hidden: true,
      icon: `${import.meta.env.VITE_ASSETS_URL}/icons/exorde-reddit.svg`,
      label: "Reddit Post Comment",
    },
    {
      appLabel: "Blog Posts",
      checked: true,
      color: "#F06A35",
      featureFlag: "view_blog_post",
      field: MentionType.blog_post,
      hidden: true,
      icon: `${import.meta.env.VITE_ASSETS_URL}/icons/blog.svg`,
      label: "Blog Post",
    },
    {
      appLabel: "Forum Posts",
      checked: true,
      color: "#FFB649",
      featureFlag: "view_forum_post",
      field: MentionType.forum_post,
      hidden: true,
      icon: `${import.meta.env.VITE_ASSETS_URL}/icons/forum.svg`,
      label: "Forum Post",
    },
    {
      appLabel: "Bluesky Posts",
      checked: true,
      color: "#1285FE",
      featureFlag: "view_bluesky_post",
      field: MentionType.bluesky_post,
      hidden: true,
      icon: `${import.meta.env.VITE_ASSETS_URL}/icons/bluesky.svg`,
      label: "Bluesky Post",
    },
    {
      appLabel: "Linkedin Posts",
      checked: true,
      color: "#0274B3",
      featureFlag: "view_linkedin_post",
      field: MentionType.linkedin_post,
      hidden: true,
      icon: `${import.meta.env.VITE_ASSETS_URL}/icons/linkedin.svg`,
      label: "LinkedIn Post",
    },
    {
      appLabel: "Linkedin Comments",
      checked: true,
      color: "#0274B3",
      featureFlag: "view_linkedin_post",
      field: MentionType.linkedin_comment,
      hidden: true,
      icon: `${import.meta.env.VITE_ASSETS_URL}/icons/linkedin.svg`,
      label: "LinkedIn Comment",
    },
    {
      appLabel: "TikTok Posts",
      checked: true,
      color: "#FE2C55",
      featureFlag: "view_tiktok_video",
      field: MentionType.tiktok_video,
      hidden: true,
      icon: `${import.meta.env.VITE_ASSETS_URL}/icons/tiktok.svg`,
      label: "TikTok Post",
    },
    {
      appLabel: "TikTok Comments",
      checked: true,
      color: "#FE2C55",
      featureFlag: "view_tiktok_video",
      field: MentionType.tiktok_comment,
      hidden: true,
      icon: `${import.meta.env.VITE_ASSETS_URL}/icons/tiktok.svg`,
      label: "TikTok Comment",
    },
  ],
  sourceLabel: "Source",
  triggerAlert: false,
};
